import { Config } from 'aws-sdk';
import {
  CognitoUserPool,
  CognitoUserAttribute
} from 'amazon-cognito-identity-js';
import { hasJwtTokenExpired } from '../helpers/Util';
import JWTTokenExpireError from '../helpers/errors/JWTTokenExpireError';

function addCognitoUser(userInfo, config) {
  const userPool = new CognitoUserPool({
    UserPoolId: config.UserPoolId,
    ClientId: config.ClientId,
  });

  const attributeList = [];

  Config.region = config.region;

  attributeList.push(new CognitoUserAttribute({ Name: 'email', Value: userInfo.email }));

  const prom = new Promise((resolve, reject) => {
    if (hasJwtTokenExpired(localStorage.getItem('jwtToken'))) {
      reject(new JWTTokenExpireError('Your session has timed out. Any unsaved changes have been lost. Please log in again.'));
    } else {
      userPool.signUp(userInfo.userName, userInfo.password, attributeList, null, (err, result) => {
        if (err) {
          reject(err);
        } else {
          resolve(result);
        }
      });
    }
  });

  return prom;
}

export default function addUser(userInfo, config) {
  console.log(`adduser action: ${userInfo}`);
  return dispatch => dispatch({
    type: 'ADD_USER_FETCH',
    payload: addCognitoUser(userInfo, config)
  });
}



// WEBPACK FOOTER //
// ./src/actions/addUser.js